import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppletContainerModel, bl_applet_ext_RowClass } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
@Component({
  selector: 'app-sidebar-personalization',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class PersonalizationSidebarComponent implements OnInit, OnDestroy {

  @Input() appletSettings$: Observable<AppletContainerModel>;
  @Input() logoBgColorInit$: Observable<{background: string}>;
  @Input() sidebarBgColorInit$: Observable<{background: string}>;

  @Output() save = new EventEmitter<AppletContainerModel>();
  @Output() logoBgChange = new EventEmitter<string>();
  @Output() sidebarBgChange = new EventEmitter<string>();

  private subs = new SubSink();

  apiVisa = AppConfig.apiVisa;

  appletContainer: AppletContainerModel;

  logoBg = new FormControl();
  sidebarBg = new FormControl();

  constructor() { }

  ngOnInit() {
    // this.subs.sink = this.logoBgColorInit$.subscribe({next: resolve => this.logoBg.patchValue(resolve.background)});
    // this.subs.sink = this.sidebarBgColorInit$.subscribe({next: resolve => this.sidebarBg.patchValue(resolve.background)});
  }

  onReset() {
    this.logoBgChange.emit('#7b68ee');
    this.sidebarBgChange.emit('#ffffff');
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
